export default "__VITE_ASSET__effb879c__"